import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { DeleteOutlined } from '@mui/icons-material';
import { Checkbox, Tab, Tabs } from '@mui/material';
import { SortDirectionArrow } from '~/components/dashboard/SortDirectionArrow';
import dayjs from 'dayjs';
// import { IUser } from "~/interfaces";
import { useAuth } from "~/hooks/useAuth";
import axios from "axios";
import { AddTaskModal } from "~/components/tasks/AddTaskModal";
import { useQueryClient } from "react-query";
import { PatientHubTaskRow } from './PatientHubTaskRow';
import { UserSelectorLayout } from '../trends/BillingTrends/UserSelectorLayout';
export const PatientHubTasks = (props) => {
    // Replace useState and manual fetch with the hook
    const { tasks, patientId } = props;
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isSelectAll, setIsSelectAll] = useState(true);
    const [selectedTaskIds, setSelectedTaskIds] = useState([]);
    const [sortingField, setSortingField] = useState('');
    const [sortingDirectionField, setSortingDirectionField] = useState('DESC');
    // const [users, setUsers] = useState<IUser[]>([]);
    // const [selectedUser, setSelectedUser] = React.useState('');
    const { userProfile } = useAuth();
    const [showAddTasksModal, setShowAddTasksModal] = useState(false);
    const queryClient = useQueryClient();
    const [currentUrl, setCurrentUrl] = useState('');
    const [selectedUserIds, setSelectedUserIds] = useState([userProfile ? userProfile.id : '']);
    useEffect(() => {
        setCurrentUrl(window.location.href);
    }, []);
    // const handleChange = (event) => {
    //     console.log(event);
    //     const userId = event.target.value;
    //     setSelectedUser(userId);
    // };
    // const getFilteredUsers = () => {
    //     // Remove current user from the list
    //     return users.filter(user => user.id !== userProfile?.id);
    // };
    // Header classes
    const tHeaderCellClass = 'table-cell align-middle';
    const tHeaderWrapperClass = 'items-center text-center';
    const tHeaderWrapperClassCheckbox = 'flex items-center text-center';
    const tHeaderTextClass = "text-s font-small font-['Barlow'] tracking-wide text-black text-opacity-87 cursor-pointer inline-flex";
    // useEffect(() => {
    //     getUsersForClinic();
    // }, []);
    // const getUsersForClinic = async () => {
    //     const users = await getUsersForPractice();
    //     setUsers(users.users);
    // };
    const getColumns = () => {
        const baseColumns = [
            { field: 'Due Date', label: 'Due Date', sortable: true, isTimestamp: false },
            { field: 'Assigned To', label: 'Assigned To', sortable: true, isTimestamp: false },
            { field: 'Assigned By', label: 'Assigned By', sortable: true, isTimestamp: false },
            { field: 'Notes', label: 'Notes', sortable: false, isTimestamp: false },
            { field: 'Status', label: 'Status', sortable: true, isTimestamp: false },
        ];
        // Only add "Completed At" column when on "Done" tab (index 3)
        if (selectedIndex === 1) {
            baseColumns.push({
                field: 'Completed At',
                label: 'Completed At',
                sortable: true,
                isTimestamp: false
            });
        }
        return baseColumns;
    };
    const handleSort = (field) => {
        if (sortingField === field) {
            // Toggle direction if same field
            const newDirection = sortingDirectionField === 'ASC' ? 'DESC' : 'ASC';
            console.log('New Direction');
            console.log(newDirection);
            setSortingDirectionField(newDirection);
        }
        else {
            // New field, start with ASC
            console.log('new field');
            setSortingDirectionField('ASC');
        }
        setSortingField(field);
    };
    const renderHeaders = () => {
        return getColumns().map((column) => (React.createElement("div", { key: column.field, className: tHeaderCellClass },
            React.createElement("div", { className: tHeaderWrapperClass },
                React.createElement("h3", { className: tHeaderTextClass, onClick: column.sortable ? () => handleSort(column.field) : undefined, style: { cursor: column.sortable ? 'pointer' : 'default' } },
                    React.createElement("div", { className: 'mt-auto mb-auto' }, column.label),
                    sortingField === column.field && column.sortable && (React.createElement("div", { className: 'mt-auto mb-auto' },
                        React.createElement(SortDirectionArrow, { sortDirection: sortingDirectionField, isTimestamp: true }))))))));
    };
    const toggleOneRecordSelected = (taskId) => {
        const newSelectedIds = [...selectedTaskIds];
        if (newSelectedIds.includes(taskId)) {
            newSelectedIds.splice(newSelectedIds.indexOf(taskId), 1);
        }
        else {
            newSelectedIds.push(taskId);
        }
        setSelectedTaskIds(newSelectedIds);
    };
    const toggleAllRecordSelected = () => {
        if (isSelectAll) {
            const newSelectedIds = [...selectedTaskIds];
            getSortedTasks(getFilteredTasks()).map((task) => {
                newSelectedIds.push(task.id);
            });
            setSelectedTaskIds(newSelectedIds);
        }
        else {
            const newSelectedIds = [...selectedTaskIds];
            newSelectedIds.splice(0, newSelectedIds.length);
            setSelectedTaskIds(newSelectedIds);
        }
        setIsSelectAll(!isSelectAll);
    };
    const handleTaskUpdate = (updatedTask) => {
        console.log('Updated Task');
        // Invalidate the query to refetch fresh data
        queryClient.invalidateQueries(['tasksForPatient', patientId]);
        queryClient.invalidateQueries(['getPatientTimeline', patientId]);
    };
    const getFilteredTasks = () => {
        let filteredTasks;
        // First filter by tab selection
        switch (selectedIndex) {
            case 0: // Due Today, upcoming, and overdue all in one category (i.e. not done)
                filteredTasks = tasks.filter(task => task.status !== 'Done');
                break;
            case 1: // Done
                filteredTasks = tasks.filter(task => task.status === 'Done');
                break;
            default:
                filteredTasks = tasks;
        }
        // Then filter by selected user
        // if (!selectedUser || selectedUser === 'my-tasks') {
        //     // Show current user's tasks
        //     return filteredTasks.filter(task => task.assignedTo == userProfile?.id);
        // } else if (selectedUser === 'all-users') {
        //     // Show all tasks - no user filtering
        //     return filteredTasks;
        // } else {
        //     // Show selected user's tasks
        //     return filteredTasks.filter(task => task.assignedTo == selectedUser);
        // }
        return filteredTasks.filter(task => selectedUserIds.includes(task.assignedTo));
    };
    const getSortedTasks = (tasksToSort) => {
        if (!sortingField)
            return tasksToSort;
        return [...tasksToSort].sort((a, b) => {
            let aValue, bValue;
            switch (sortingField) {
                case 'TaskName':
                    aValue = a.taskName?.toLowerCase() || '';
                    bValue = b.taskName?.toLowerCase() || '';
                    break;
                case 'Due Date':
                    aValue = dayjs(a.dueDate).valueOf();
                    bValue = dayjs(b.dueDate).valueOf();
                    break;
                case 'Assigned To':
                    aValue = a.assignedToName?.toLowerCase() || '';
                    bValue = b.assignedToName?.toLowerCase() || '';
                    break;
                case 'Assigned By':
                    aValue = a.assignedByName?.toLowerCase() || '';
                    bValue = b.assignedByName?.toLowerCase() || '';
                    break;
                case 'Status':
                    aValue = a.status?.toLowerCase() || '';
                    bValue = b.status?.toLowerCase() || '';
                    break;
                case 'Completed At':
                    aValue = a.completedAt ? dayjs(a.completedAt).valueOf() : 0;
                    bValue = b.completedAt ? dayjs(b.completedAt).valueOf() : 0;
                    break;
                default:
                    return 0;
            }
            if (aValue < bValue)
                return sortingDirectionField === 'ASC' ? -1 : 1;
            if (aValue > bValue)
                return sortingDirectionField === 'ASC' ? 1 : -1;
            return 0;
        });
    };
    const deleteTasks = async () => {
        await axios.post('/api/tasks/deleteTasks', {
            taskIds: selectedTaskIds
        });
        // Refetch tasks after deletion
        queryClient.invalidateQueries(['tasksForPatient', patientId]);
        queryClient.invalidateQueries(['getPatientTimeline', patientId]);
        // queryClient.invalidateQueries(['tasksCount']);
        setSelectedTaskIds([]);
        setIsSelectAll(true);
    };
    const handleTaskAdded = () => {
        // Invalidate queries to refetch fresh data
        queryClient.invalidateQueries(['tasksForPatient', patientId]);
        queryClient.invalidateQueries(['getPatientTimeline', patientId]);
        // queryClient.invalidateQueries(['tasksCount']);
        setShowAddTasksModal(false);
    };
    return (React.createElement("div", { className: "rounded bg-white pl-4 pt-4 pb-4 space-y-4 block justify-start h-full" },
        React.createElement("div", { className: "flex h-full w-full" },
            React.createElement("div", { className: "h-full flex-grow overflow-y-auto overflow-x-hidden" },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { style: { color: '#000', fontWeight: '400', fontFamily: 'Barlow', fontSize: '24px' } }, "Patient Tasks"),
                    React.createElement("div", { style: { display: 'flex', marginLeft: 'auto', marginRight: '10px' } },
                        React.createElement(Button, { onClick: () => setShowAddTasksModal(true), sx: { textTransform: 'none' }, style: {
                                fontWeight: 'bold',
                                marginLeft: 5,
                                marginRight: 5,
                                borderRadius: 16,
                                paddingLeft: 10,
                                paddingRight: 10
                            }, variant: 'outlined', size: "small" }, "Add Task"),
                        React.createElement(Button, { onClick: deleteTasks, sx: { textTransform: 'none' }, style: {
                                fontWeight: 'bold',
                                marginLeft: 5,
                                marginRight: 5,
                                paddingLeft: 10,
                                paddingRight: 10,
                                color: '#D32F2F',
                                borderRadius: 16,
                                borderColor: '#D32F2F',
                                display: selectedTaskIds.length > 0 ? 'flex' : 'none'
                            }, variant: 'outlined', size: "small", startIcon: React.createElement(DeleteOutlined, { style: { color: '#D32F2F' } }) }, "Delete"))),
                React.createElement("div", { style: { marginTop: '10px', marginBottom: '10px', width: '100%', height: '1px', border: '1px rgba(0, 0, 0, 0.12) solid' } }),
                React.createElement("div", { className: "flex items-center mt-2" },
                    React.createElement(UserSelectorLayout, { setSelectedUsers: setSelectedUserIds, initialSelectedUser: selectedUserIds })),
                React.createElement("div", { className: "flex items-center mt-2" },
                    React.createElement(Tabs, { value: selectedIndex, onChange: () => console.log('changed'), color: '#2C78EB', sx: {
                            minHeight: '0px', height: '45px', '.Mui-selected': {
                                color: '#2C78EB',
                            }
                        } },
                        React.createElement(Tab, { id: 'dueToday', label: 'To Do', value: 0, className: "inline-block padding-text", key: 0, onClick: () => { setSelectedIndex(0); }, sx: { fontWeight: 'bold', minHeight: '0px', height: '45px', opacity: '1', color: selectedIndex === 0 ? '#2C78EB' : '#00000099' } }),
                        React.createElement(Tab, { id: 'done', label: 'Done', value: 1, className: "inline-block padding-text", key: 3, onClick: () => { setSelectedIndex(1); }, sx: { fontWeight: 'bold', minHeight: '0px', height: '45px', opacity: '1', color: selectedIndex === 1 ? '#2C78EB' : '#00000099' } }))),
                React.createElement("div", { className: "overflow-x-auto w-full" },
                    React.createElement("div", { className: "table table-auto border-collapse mt-8 w-full min-w-max", id: "patients-table" },
                        React.createElement("div", { className: "table-row" },
                            React.createElement("div", { className: tHeaderCellClass },
                                React.createElement("div", { className: tHeaderWrapperClassCheckbox },
                                    React.createElement("div", { className: tHeaderWrapperClass },
                                        React.createElement("div", { onClick: () => { toggleAllRecordSelected(); } },
                                            React.createElement(Checkbox, { style: { marginRight: '10px' }, size: "medium", color: "primary", checked: !isSelectAll }))),
                                    React.createElement("div", { className: tHeaderTextClass, onClick: () => handleSort('TaskName'), style: { cursor: 'pointer' } },
                                        React.createElement("div", { className: 'mt-auto mb-auto' }, "Tasks"),
                                        sortingField === 'TaskName' && (React.createElement("div", { className: 'mt-auto mb-auto' },
                                            React.createElement(SortDirectionArrow, { sortDirection: sortingDirectionField, isTimestamp: true })))))),
                            renderHeaders()),
                        getSortedTasks(getFilteredTasks()).map((task) => (React.createElement(PatientHubTaskRow, { key: task.id, task: task, taskSelected: (taskId) => {
                                toggleOneRecordSelected(taskId);
                            }, selectedTaskIds: selectedTaskIds, onTaskUpdate: handleTaskUpdate, doneSelected: selectedIndex === 1 }))))),
                showAddTasksModal && React.createElement(AddTaskModal, { onRequestClose: () => setShowAddTasksModal(false), url: currentUrl, onTaskAdded: handleTaskAdded })))));
};
